import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StepsComponent} from './steps/steps.component';
import {StepPageComponent} from './step-page/step-page.component';
import {StepPageBodyComponent} from './step-page-body/step-page-body.component';
import {LayoutsModule} from '../layouts/layouts.module';
import {NgZorroAntdModule} from 'ng-zorro-antd';


@NgModule({
    declarations: [
        StepsComponent,

        StepPageComponent,

        StepPageBodyComponent,


    ],
    imports: [
        CommonModule, NgZorroAntdModule,
        LayoutsModule

    ],
    exports: [
        StepsComponent,

        StepPageComponent,

        StepPageBodyComponent,

    ]
})
export class StepModule {
}
